import { isStructureVulnerable } from '../structures.js';

/**
 * structureDamageGate — Block damage to structures still gated by requires.
 * Peers must be the full structure list (including dead) via structure.structurePeers.
 *
 * @returns {{ hp, killed, blocked, effectiveDamage, isCrit } | null}
 *   null → damage may proceed; object → blocked no-op result
 */
export function structureDamageBlockResult(structure) {
  if (!structure || !structure.requires) return null;
  const peers = structure.structurePeers;
  if (!Array.isArray(peers) || !isStructureVulnerable(structure, peers)) {
    return {
      hp: structure.hp,
      killed: false,
      blocked: true,
      effectiveDamage: 0,
      isCrit: false
    };
  }
  return null;
}
